
export class DateRange {
    start?: Date;
    end?: Date;
}
